import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import overshootInTopGif from '../../../assets/images/transitions/overshootInTop.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_OVERSHOOT_IN_TOP = 'overshootInTop';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   humanName: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const overshootInTopPresetDetails = {
  // The name of the preset.
  name: PRESET_OVERSHOOT_IN_TOP,

  // A human friendly name for the preset.
  humanName: 'Overshoot In From Top',

  // A preview of the transition.
  gif: overshootInTopGif,

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'position.y': {
      // The name of the easing this property will use.
      easing: EASINGS.easeOutBack,

      // The start and end times for the transition of this property.
      time: {
        start: 'start.0',
        end: 'start.1000',
      },

      // The value of the property that will change during the transition.
      values: [
        'off.top',
        'position.top'
      ],
    },
    immediateRender: true
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_OVERSHOOT_IN_TOP,
    options: {},
  },
};

overshootInTopPresetDetails.template.options = lodash.cloneDeep(overshootInTopPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_OVERSHOOT_IN_TOP;

// This defines the value of the presets object.
export default overshootInTopPresetDetails;
